export const getAllLocations = (state) => {
  return state.locations.locationIds.map((id) => state.locations.locationsById[id]);
};

export const getCarouselLocations = (state) => {
  const locations = getAllLocations(state);
  const filteredLocations = locations.filter((item) => item.displayInCarousel);

  return filteredLocations;
};

export const getLocationById = (state, id) => {
  return state.locations.locationsById[id];
};

export const getLocationByUrl = (state, url) => {
  const locations = getAllLocations(state);

  return locations.find((item) => item.friendly_url === url) || false;
};
